import React, { Fragment, useState, useEffect } from "react";
import { Col, Row } from "antd";
import RightBar from "../../../../common/righbar";
import { SideBar } from "../../../../common/sidebar";
import EventCard from "../../../../common/cards/Events/EventCard";
import { GetOrganizerDraftedEvents } from "../../../../Config/API/events";
import { error } from "../../../../common/Alerts/Message";
import Loader from "../../../../common/cards/Loader";
import { useSelector } from "react-redux";
import { PROFILE } from "../../../../Store/Features/ProfileSlice";
import NoData from "../../../../common/cards/noData";
import EventChangeTabs from "../EventChangeTabs";
import { ROLES } from "../../../../Config/helpers/constants";

const DraftEvents = () => {
  const ID = useSelector(PROFILE);
  const panelid = localStorage.getItem("panel");
  const [Events, setEvents] = useState([]);
  const [loading, setloading] = useState(false);
  const getallevents = async () => {
    try {
      setloading(true);
      const response = await GetOrganizerDraftedEvents();
      const data = await response.json();

      // const filter = data?.result?.filter((e) => {
      //   // return e
      //   return new Date(e?.endDate).setHours(24) >= new Date();
      // });
      setEvents(data?.result);
      setloading(false);
    } catch (e) {
      error(e || "An Error Occured");
      setloading(false);
    }
  };
  useEffect(() => {
    if (ID?._id || panelid) {
      getallevents();
    }
    return () => setEvents([]);
  }, [ID?._id, panelid]);
  return (
    <Fragment>
      {loading && <Loader fullpage loading={"white"} />}
      <Row justify="space-between" className="rowPadding">
        <SideBar description experience />
        <Col
          xs={{ span: 24, order: 3 }}
          sm={{ span: 24, order: 3 }}
          md={{ span: 24, order: 3 }}
          lg={{ span: 11, order: 2 }}>
          <Row className="mobileto">
            <EventChangeTabs type="drafted" user={ROLES.organizer} />

            {Events?.length > 0 ? (
              Events?.map((e, i) => <EventCard key={e?._id + i} data={e} drafted={true} />)
            ) : (
              <NoData noEvent />
            )}
          </Row>
        </Col>
        <RightBar />
      </Row>
    </Fragment>
  );
};

export default DraftEvents;
